type GoalFunding = {
	totalValue: number;
	ownFunds: number;
	loanAmount?: number;
};

export const getGoalOverpaidExcess = ({
	totalValue,
	ownFunds,
	loanAmount = 0,
}: GoalFunding): number =>
	totalValue > 0 ? Math.max(0, ownFunds + loanAmount - totalValue) : 0;
